/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_1_AnswerInputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_1_answer = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_1_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. File support describes what an app can read and write. Compatibility also includes calculation behavior, formatting, advanced objects and how another application reads the saved result. Check the actual workbook, not just its extension.`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_1_answer = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_1_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不等于。格式支持说明应用能够读取和写入哪些文件；兼容性还包括计算行为、格式、高级对象，以及其他应用如何读取保存后的文件。因此需要验证具体文件，而不能只看扩展名。`)
};

/**
* | output |
* | --- |
* | "No. File support describes what an app can read and write. Compatibility also includes calculation behavior, formatting, advanced objects and how another app..." |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_1_AnswerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_1_answer = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_1_AnswerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_8_Questions_1_AnswerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_1_answer(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_1_answer(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_8_questions_1_answer as "gc.search_guides.gridcraft_excel_compatibility.sections.8.questions.1.answer" }